import { api } from "@/axios";
import responseHandler from "@/responseHandler.js";

const state = {
  marks: [],
  checkedMarkExists: null,
  x: -1,
};

const getters = {
  getMarks: (state) => state.marks,
  getMarkById: (state) => (id) => state.marks.find((x) => x.id == id),
  getCheckedMarkExists: (state) => state.checkedMarkExists,
};

const actions = {
  async exportMarks() {
    try {
      const resp = await api.get("/marks_export");
      if (resp.status == 200) {
        return resp.status;
      }
    } catch (error) {
      console.log("error", error);
      return error.status;
    }
  },
  async checkMarkExists({ commit }, stu_num) {
    try {
      const resp = await api.get(`/mark_check/${stu_num}`);
      if (resp.status == 200) {
        const mark = resp.data.data.mark;
        //.log("students", student);
        commit("setCheckedMarkExists", mark);
        return 200;
      } else {
        commit("setCheckedMarkExists", null);
      }
    } catch (error) {
      //   console.log("error", error.status);
      //   console.log("error", error);
      commit("setCheckedMarkExists", null);
      return error.status;
    }
  },
  async changeMarkStatus({ commit }, data) {
    try {
      const resp = await api.post(`/marks/${data.id}/change_status`, {
        status: data.status,
      });

      if (resp.status == 200) {
        const mark = resp.data.data;
        commit("updateMarkStatus", mark);
        return 200;
      }
    } catch (error) {
      return error.status;
    }
  },

  async confirmMarkApp({ commit }, data) {
    console.log("data recived", data);
    try {
      const resp = await api.post(`/marks/${data}/confirm`);
      //console.log("resp after", resp.status);
      if (resp.status == 200) {
        const mark = resp.data.data;
        //console.log("mark after", mark);
        commit("setCheckedMarkExists", mark);
        //return 200;
        return true;
      } else {
        //return resp.status;
        return false;
      }
    } catch (error) {
      //return error.status;
      return false;
    }
  },
  async fetchMarks({ commit }) {
    try {
      const resp = await api.get("/marks");
      if (resp.status == 200) {
        const marks = resp.data.data.marks;
        console.log("marks", marks);
        commit("setMarks", marks);
      }
    } catch (error) {
      console.log("error", error);
      return false;
    }
  },
  async updateMark({ commit }, mark) {
    console.log("mark", mark);

    try {
      const id = mark.id;
      mark._method = "patch";

      const resp = await api.post(`/marks/${id}`, mark);
      if (resp.status == 200) {
        const mark = resp.data.data;
        console.log("mark back", mark);
        commit("updateMark", mark);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      console.log("error", error);
      return responseHandler.respH1(error.response);
    }
  },
  async addMark({ commit }, mark) {
    try {
      const resp = await api.post(`/marks`, mark);

      if (resp.status == 201) {
        const mark = resp.data.data;

        commit("addMark", mark);
      }
      console.log("resp:", resp);
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
  async deleteMark({ commit }, id) {
    try {
      const resp = await api.delete(`/marks/${id}`);

      if (resp.status == 204) {
        commit("deleteMark", id);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },

  //   async addAttachment({ commit }, att) {
  //     try {
  //       const formData = new FormData();
  //       formData.append("attachment", att.attachment);

  //       formData.append("name", att.name);

  //       const resp = await api.post(
  //         `/marks/${att.mark_id}/attachments`,
  //         formData,
  //       );

  //       if (resp.status == 201) {
  //         const att = resp.data.data;

  //         commit("addAttachment", att);
  //       }
  //       return responseHandler.respH1(resp);
  //     } catch (error) {
  //       return responseHandler.respH1(error.response);
  //     }
  //   },

  async updateMarkAttachment({ commit }, att) {
    try {
      const formData = new FormData();
      formData.append("link", att.link);
      formData.append("name", att.name);
      formData.append("_method", "patch");

      const resp = await api.post(`/attachments/${att.id}`, formData);
      if (resp.status == 200) {
        const att = resp.data.data;
        commit("updateAttachment", att);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      console.log("error", error);
      return responseHandler.respH1(error.response);
    }
  },
};

const mutations = {
  setMarks(state, mark) {
    state.marks = mark;
  },
  updateMark(state, mark) {
    const id = mark.id;
    const index = state.marks.findIndex((mark) => mark.id == id);
    if (index !== -1) {
      state.marks[index] = mark;
    }
  },
  addMark(state, mark) {
    state.marks.unshift(mark);
  },

  deleteMark(state, id) {
    const index = state.marks.findIndex((p) => p.id == id);
    if (index !== -1) {
      state.marks.splice(index, 1);
    }
  },

  //   addAttachment(state, att) {
  //     const index = state.checkedMarkExists.attachments.findIndex(
  //       (a) => a.id === att.id,
  //     );
  //     if (index !== -1) {
  //       // Replace existing attachment without Vue.set
  //       state.checkedMarkExists.attachments.splice(index, 1, att);
  //     } else {
  //       // Add new attachment
  //       state.checkedMarkExists.attachments.push(att);
  //     }
  //   },
  updateAttachment(state, att) {
    state.x = att.id;
  },

  setCheckedMarkExists(state, mark) {
    state.checkedMarkExists = mark;
  },
  updateMarkStatus(state, mark) {
    const index = state.marks.findIndex((x) => x.id == mark.id);
    if (index != -1) {
      state.marks[index].status = mark.status;
      //console.log("cfdfciv uhiuhc", mark.status);
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
